import { WordObject } from "./interfaces/word-object/WordObject";

export class HelperService {
    static validateEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }
    static isPersian(text: string) {
        return /[\u0600-\u06FF]/.test(text);
    }
    static isVerb(wordObject: WordObject) {
        const isVerb = wordObject.artikel == "-" &&
            wordObject?.word?.slice(-1) == "n" &&
            wordObject?.word.trim().split(" ").length < 2 &&
            wordObject?.word.trim().length > 3 &&
            !(wordObject.translation && wordObject.translation.includes("nothing found"));
        return isVerb;
    }
    static waitForTimeout(timeOut: number) {
        return new Promise((resolve) => {
          setTimeout(resolve, timeOut);
        });
      }
    static cleanToJson(jsonText: string) {
        jsonText = jsonText.replace(/```json\n|```/g, '');
        let cleanText = jsonText.replace(/<s>/g, "'").replace(/<\/s>/g, "'");
        let jsonString = this.escapeInnerQuotes(cleanText);
        jsonString = this.escapeInnerQuotes(jsonString);
        jsonString = this.escapeInnerQuotes(jsonString);
        jsonString = this.escapeInnerQuotes(jsonString);
        jsonString = this.escapeInnerQuotes(jsonString);
        jsonString = this.escapeInnerQuotes(jsonString);
        jsonString = this.escapeInnerQuotes(jsonString);
        jsonString = jsonString.replace(/\*/g, "");
        jsonString = jsonString.replace(/_/g, "");
        return jsonString;
    }
    static escapeInnerQuotes(jsonString:string ) {
        jsonString = jsonString.replace(/":\s*"(.*)",/g, (match, p1) => {
            return `": "${p1.replace(/"/g, "'")}",`;
        });        
        jsonString = jsonString.replace(/":\s*"(.*)"\s*}/g, (match, p1) => {
            return `": "${p1.replace(/"/g, "'")}"\n}`;
        });
        jsonString =jsonString.replace(/\\'/g,"'")
        return jsonString;
    }

    static isVerbByStribg(word: string) {
        const isVerb = 
        word?.slice(-1) == "n" &&
        word.trim().split(" ").length < 2 &&
        word.trim().length > 3;
        // this.logger.debug("isVerb", isVerb, word);
        return isVerb;
    }
}